import React, { useState } from "react";
import {
    CategoryFilterOption,
    CategoryFilterWrapper,
    FilterBarWrapper,
} from "./Styled";
import DropdownMenu from "../../../../../../../shared/components/DropdownMenu.tsx";

interface FilterBarProps {
    currentOption: string;
    options: string[];
    onChangeOption: Function;
    dropdownMenuList: { text: string }[];
    selectedMenuItem: string;
    onClickSelectMenuItem: Function;
}

export const FilterBar = ({
    currentOption,
    options,
    onChangeOption,
    dropdownMenuList,
    selectedMenuItem,
    onClickSelectMenuItem,
}: FilterBarProps) => {
    const [selectedType, setSelectedType] = useState(currentOption);

    const onClickSelect = (option: string) => {
        setSelectedType(option);
        onChangeOption(option);
    };

    return (
        <FilterBarWrapper>
            <DropdownMenu
                menuList={dropdownMenuList}
                menuText={selectedMenuItem}
                handleOnclickItem={(item: any) => {
                    onClickSelectMenuItem(item.text);
                }}
                style={{
                    flex: 1,
                    maxWidth: "150px",
                    height: "25px",
                    padding: "8px 12px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "5px",
                    lineHeight: "22",
                    fontWeight: "400",
                    fontSize: "14px",
                    appearance: "none",
                }}
            />

            <CategoryFilterWrapper>
                {options.map((option) => (
                    <CategoryFilterOption
                        isSelected={selectedType === option}
                        onClick={() => onClickSelect(option)}
                    >
                        {option}
                    </CategoryFilterOption>
                ))}
            </CategoryFilterWrapper>
        </FilterBarWrapper>
    );
};
